<template>
  <v-icon
    :data-testid="sectionTag"
    :icon="mdiHelpCircle"
    class="question_icon"
  ></v-icon>
</template>

<script setup lang="ts">
import { colors } from '@/plugins/vuetify'
import { mdiHelpCircle } from '@mdi/js'
export interface IconQuestionProps {
  sectionTag?: string
  size?: string
}

withDefaults(defineProps<IconQuestionProps>(), {
  sectionTag: 'unspecified',
  size: '14px'
})


</script>

<style scoped>
.question_icon {
  color: v-bind('colors.neutral.neutral1000') !important;
  font-size: v-bind('size') !important;
}

.question_icon:hover {
  color: v-bind('colors.blue.blue600') !important;
}
</style>
